"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ValidationErrors_1 = require("../../../../enums/Validation/ValidationErrors");
const Custom_1 = __importDefault(require("../../../decorators/Custom"));
const Resource_1 = __importDefault(require("../../../Resource"));
class ContributorRequestResource extends Resource_1.default {
}
exports.default = ContributorRequestResource;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsOptional)(),
    (0, Custom_1.default)((_firstName, args) => args.object.lastName !== undefined, {
        message: ValidationErrors_1.EValidationError.lastNameIsRequired,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ContributorRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsOptional)(),
    (0, Custom_1.default)((_lastName, args) => args.object.firstName !== undefined, {
        message: ValidationErrors_1.EValidationError.firstNameIsRequired,
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ContributorRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ContributorRequestResource.prototype, "companyName", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((object) => !object.firstName && !object.lastName && !object.companyName),
    (0, class_validator_1.IsDefined)({ message: "At least one of firstName, lastName or companyName must be provided" }),
    __metadata("design:type", void 0)
], ContributorRequestResource.prototype, "atLeastOne", void 0);
